import * as React from "react"
import { type ReactNode } from "react"
import {
  ApplicationTitle,
  ApplicationTitleContainer,
} from "@digits-shared/DesignSystem/Containers/Headers/ApplicationTitle"
import { ApplicationTopSection } from "@digits-shared/DesignSystem/Containers/Headers/ApplicationTopSection"
import { HeaderButtons } from "@digits-shared/DesignSystem/Containers/Headers/HeaderButtons"
import { HeaderSubNav } from "@digits-shared/DesignSystem/Containers/Headers/HeaderSubNav"
import { HeaderSearchBox } from "src/frontend/components/OS/Applications/Search/SearchBox/HeaderSearchBox"
import { ApplicationHeaderPortal } from "src/frontend/components/OS/Applications/Shared/Headers/ApplicationHeaderPortal"
import { AgentSummaryButton } from "src/frontend/components/Shared/Assistant/Agents/AgentSummaryButton"
import { AssistantHeaderButton } from "src/frontend/components/Shared/Assistant/AssistantHeaderButton"

/*
  INTERFACE
*/

interface HeaderProps {
  children: ReactNode
  SubNav?: React.ComponentType
}

/**
 * A custom header component for Applications with AI buttons like Home or Inbox
 */
export const ApplicationHeaderWithAI: React.FC<HeaderProps> = ({ children, SubNav }) => (
  <ApplicationTopSection>
    <ApplicationTitleContainer>
      <ApplicationTitle>{children}</ApplicationTitle>

      <HeaderButtons>
        <AgentSummaryButton />
        <AssistantHeaderButton />
        <HeaderSearchBox />
      </HeaderButtons>
    </ApplicationTitleContainer>

    {SubNav && (
      <HeaderSubNav>
        <SubNav />
      </HeaderSubNav>
    )}

    <ApplicationHeaderPortal id="application-header-portal" />
  </ApplicationTopSection>
)
